import { FEATURES, HERO_IMAGE_SIMPLE } from "../data/mock";
import { Bot, Plus, FileText, BarChart3, BookOpen, CalendarDays, Save, Compass } from "lucide-react";

const iconMap = { Bot, Plus, FileText, BarChart3, BookOpen, CalendarDays, Save, Compass };

export const FeaturesSection = () => {
  return (
    <section id="features" className="relative py-24 lg:py-32 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 bg-white" />
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#0049B3]/10 to-transparent" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section header */}
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between mb-20">
          <div className="max-w-2xl">
            <div className="inline-flex items-center gap-2 bg-[#0049B3]/5 border border-[#0049B3]/10 rounded-full px-4 py-2 mb-6">
              <span className="text-sm font-semibold text-[#0049B3]" style={{ fontFamily: "'Inter', sans-serif" }}>
                Klíčové funkce
              </span>
            </div>
            <h2
              className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-[#0F1B3D]"
              style={{ fontFamily: "'Plus Jakarta Sans', sans-serif", lineHeight: '1.35' }}
            >
              Vše, co potřebujete k vytvoření
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#0049B3] to-[#2B7AE0]"> dokonalého ŠVP pro MŠ.</span>
            </h2>
          </div>
          {/* Hero peeking */}
          <div className="hidden lg:block relative -mb-4">
            <img src={HERO_IMAGE_SIMPLE} alt="Agent ŠVP" className="w-40 opacity-90 drop-shadow-lg" />
          </div>
        </div>

        {/* Features grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {FEATURES.map((feature, index) => {
            const Icon = iconMap[feature.icon];
            return (
              <div
                key={feature.id}
                className={`group relative rounded-3xl p-7 border transition-all duration-500 hover:-translate-y-2 ${
                  feature.highlight
                    ? "bg-gradient-to-br from-[#0049B3] to-[#003380] border-transparent shadow-xl shadow-blue-900/20 hover:shadow-2xl hover:shadow-blue-900/30"
                    : "bg-white border-[#E8EDF5] hover:border-[#0049B3]/20 hover:shadow-2xl hover:shadow-blue-900/8"
                }`}
              >
                {/* Icon */}
                <div className={`w-12 h-12 rounded-xl flex items-center justify-center mb-5 transition-transform duration-500 group-hover:scale-110 ${
                  feature.highlight ? "bg-[#FFC72C]/20" : "bg-[#0049B3]/8"
                }`}>
                  {Icon && <Icon className={`w-6 h-6 ${feature.highlight ? "text-[#FFC72C]" : "text-[#0049B3]"}`} />}
                </div>

                {/* Content */}
                <h3
                  className={`text-lg font-bold mb-3 ${feature.highlight ? "text-white" : "text-[#0F1B3D]"}`}
                  style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}
                >
                  {feature.title}
                </h3>
                <p
                  className={`text-sm leading-relaxed ${feature.highlight ? "text-blue-200/80" : "text-[#4A5B7A]"}`}
                  style={{ fontFamily: "'Inter', sans-serif" }}
                >
                  {feature.description}
                </p>

                {/* Hover accent */}
                {!feature.highlight && (
                  <div className="absolute bottom-0 left-7 right-7 h-1 bg-gradient-to-r from-[#0049B3] to-[#FFC72C] rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
